import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import PropertyService from "../../api/PropertyService";
import { RootState } from "../../store";
import { days } from "../OpeningDays/OpeningDays";

import styles from "./info-tab.module.css";

export const InfoTab = () => {
  const appointment = useSelector((state: RootState) => state.appointment);
  const task = useSelector((state: RootState) => state.task);

  const [property, setProperty] = useState<any>(null);
  const [propertyUsers, setPropertyUsers] = useState<any[]>([]);

  const propertyId =
    appointment.propertyId !== ""
      ? appointment.propertyId
      : task.additionalData.property.id;

  const fetchProperty = async () => {
    try {
      const response = await PropertyService.GetProperty(propertyId);
      setProperty(response.data);
    } catch (error) {
      console.error("Error fetching property:", error);
    }
  };

  const fetchPropertyUsers = async () => {
    try {
      const propertyResponse =
        await PropertyService.GetPropertyAccessibleUsers(propertyId);

      const propertyUsers = (propertyResponse?.data ?? []).filter((user: any) =>
        user.roles?.includes("kunde.objektbetreuer")
      );
      setPropertyUsers(propertyUsers);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!propertyId) return;

    fetchProperty();
    fetchPropertyUsers();
  }, [propertyId]);

  return (
    <div>
      <div className={styles["wrapper"]} style={{ paddingBottom: 0 }}>
        <span className={styles["title"]}>Öffnungszeiten</span>
        {days.map((day, index) => {
          const hours = property?.openingHours?.find(
            (item: any) => item.dayOfWeek === index + 1
          );

          return (
            <div key={day.dayOfWeek} className={styles["opening-hours"]}>
              <span>{day.label}</span>

              <span className={!hours?.isOpen ? styles["closed"] : ""}>
                {hours?.isOpen
                  ? `${hours.openTime} - ${hours.closeTime}`
                  : "Geschlossen"}
              </span>
            </div>
          );
        })}
      </div>

      <div className={styles["wrapper"]}>
        <span className={styles["title"]}>Bemerkungen</span>
        <div className={styles["property-users__table"]}>
          <span className={styles["property-user__email"]}>
            {property?.remark || "-"}
          </span>
        </div>
      </div>

      <div className={styles["wrapper"]}>
        <span className={styles["title"]}>Ansprechpartner</span>
        <div className={styles["property-users__table"]}>
          {propertyUsers.map((user: any) => (
            <div key={user.id} className={styles["property-user"]}>
              <span className={styles["property-user__name"]}>
                {user.firstName} {user.lastName}
              </span>{" "}
              <br />
              <span className={styles["property-user__email"]}>
                {user.email}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
